import { Yup, YupC } from "../yup";
//
//import type { AccountData } from '@/@types/data/accountData';

//import { cpf, cnpj } from "cpf-cnpj-validator";
// ---------------------------------------------------------------------- //
import { readDataStorage } from "../../../utils/storage/storage";

const { TipoVendedor } = readDataStorage("login");

const RegisterDataPF: Yup.ObjectSchema<any> = Yup.object().shape({
  pfNomeTitular: YupC.string(),
  pfEmail: YupC.string(),
  telefoneLigacao: YupC.string(),
  pfTelefone: YupC.string(),
  pfDataNasc: Yup.string(),
  enderecoCEP: YupC.string(),
  enderecoEstado: YupC.string(),
  numeroInstalacao: YupC.string().when("enderecoEstado", {
    is: "Minas Gerais",
    then: Yup.string()
      .required("Informe o número de instalação")
      .max(15, "O número da instalação é composto por até 15 dígitos"),
    otherwise: Yup.string(), // Pode ser vazio ou ter outras validações
  }),
  classe: YupC.string(),
  subGrupo: YupC.string(),
  enderecoCidade: YupC.string(),
  enderecoBairro: YupC.string(),
  enderecoLogradouro: YupC.string(),
  enderecoNumero: YupC.string(),
  concessionaria: YupC.string(),
  consorcio:
    TipoVendedor === "Pós Venda" ? YupC.string() : YupC.string().notRequired(),
  usina:
    TipoVendedor === "Pós Venda" ? YupC.string() : YupC.string().notRequired(),
});

const RegisterDataPJ: Yup.ObjectSchema<any> = Yup.object().shape({
  telefoneLigacao: YupC.string(),
  pjRazaoSocial: YupC.string(),
  pjEmail: YupC.string(),
  pjTelefone: YupC.string(),
  pjDataNasc: Yup.string(),
  pjRespEmail: YupC.string(),
  pjRespTelefone: YupC.string(),
  enderecoCEP: YupC.string(),
  enderecoEstado: YupC.string(),
  numeroInstalacao: YupC.string().when("enderecoEstado", {
    is: "Minas Gerais",
    then: Yup.string()
      .required("Informe o número de instalação")
      .max(15, "O número da instalação é composto por até 15 dígitos"),
    otherwise: Yup.string(), // Pode ser vazio ou ter outras validações
  }),
  pjRespNomeTitular: YupC.string(),
  classe: YupC.string(),
  subGrupo: YupC.string(),
  enderecoCidade: YupC.string(),
  enderecoBairro: YupC.string(),
  enderecoLogradouro: YupC.string(),
  enderecoNumero: YupC.string(),
  concessionaria: YupC.string(),
  consorcio:
    TipoVendedor === "Pós Venda" ? YupC.string() : YupC.string().notRequired(),
  usina:
    TipoVendedor === "Pós Venda" ? YupC.string() : YupC.string().notRequired(),
});

// ---------------------------------------------------------------------- //

export const registerSchemas = { RegisterDataPF, RegisterDataPJ };
